import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RestService } from './rest.service';
import { FetchScheduleHistoryPayload } from '../Inteface/fetch-schedule-history-payload';
import { ScheduleHistoryApiResponse } from '../Inteface/schedule-history-api-response';
import { FetchScheduleLogSuitesPayload } from '../Inteface/fetch-schedule-log-suites-payload';
import { ScheduleLogSuitesApiResponse } from '../Inteface/schedule-log-suites-api-response';

export { FetchScheduleHistoryPayload } from '../Inteface/fetch-schedule-history-payload';
export { ScheduleHistoryListItem } from '../Inteface/schedule-history-list-item';
export { ScheduleSuiteEntry } from '../Inteface/schedule-suite-entry';

@Injectable({
  providedIn: 'root'
})
export class SchedulerExecutionHistoryService {

  constructor(private restService: RestService) { }

  fetchScheduleHistory(payload: FetchScheduleHistoryPayload): Observable<ScheduleHistoryApiResponse> {
    return this.restService.post('fetchScheduleExecutionLogs', payload);
  }

  fetchScheduleLogSuites(payload: FetchScheduleLogSuitesPayload): Observable<ScheduleLogSuitesApiResponse> {
    return this.restService.post('fetchScheduleLogSuites', payload);
  }
}